// slices/notificationSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  loadingMore: false,
  error: null,
  pagination: null,
  hasMore: true,
};

const notificationSlice = createSlice({
  name: 'Notification',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      // Ensure we always set an array, even if payload is not an array
      if (Array.isArray(action.payload)) {
        state.notifications = action.payload;
        state.unreadCount = action.payload.filter(notification => !notification.isRead).length;
      } else {
        // If payload is not an array, set empty array and log error
        console.error('setNotifications: payload is not an array:', action.payload);
        state.notifications = [];
        state.unreadCount = 0;
      }
      state.error = null;
    },
    addNotifications: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.notifications = [...state.notifications, ...action.payload];
        state.unreadCount = state.notifications.filter(notification => !notification.isRead).length;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingMore: (state, action) => {
      state.loadingMore = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.loadingMore = false;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
      state.hasMore = action.payload ? action.payload.currentPage < action.payload.totalPages : false;
    },
    markAsRead: (state, action) => {
      const notificationId = action.payload;
      
      // Ensure notifications is an array before mapping
      if (Array.isArray(state.notifications)) {
        state.notifications = state.notifications.map(notification =>
          (notification.id === notificationId || notification._id === notificationId)
            ? { ...notification, isRead: true }
            : notification
        );
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.error = null;
      state.pagination = null;
      state.hasMore = true;
    },
  },
});

export const {
  setNotifications,
  addNotifications,
  setLoading,
  setLoadingMore,
  setError,
  setPagination,
  markAsRead,
  clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;